<template>
    <v-app-bar>
        <template v-slot:prepend>
<!--            <v-btn
                v-if="showBackButton"
                icon="mdi-arrow-left"
                @click="handleBack"
                title="Zpět"
            />-->
            <v-btn v-if="!loggedIn" @click="router.push({ name: 'Authorization' })" id="login-button" rounded="xl"
                   size="large">
                Log In
            </v-btn>

        </template>

        <v-app-bar-title>B2B XFM</v-app-bar-title>

        <template v-slot:append>
<ThemeToggle />
<!--            <v-btn @click="toggleTheme" icon="mdi-theme-light-dark"></v-btn>-->

            <v-btn @click="$emit('containerFluid')">
                <v-icon v-if="toggleStatus">mdi-fullscreen-exit</v-icon>
                <v-icon v-else>mdi-fullscreen</v-icon>
            </v-btn>

<!--            <v-btn icon="mdi-dots-vertical"></v-btn>-->
            <v-btn v-if="loggedIn" @click="authStore.logout()" icon="mdi-logout"></v-btn>
        </template>
    </v-app-bar>
</template>

<script setup>
import {useAuthStore} from "../store/userAuth.js";
import {computed, defineProps} from "vue";
import {useRouter} from "vue-router";
/*import { useTheme } from 'vuetify'*/
import ThemeToggle from '@/components/ThemeToggle.vue'
//import { goBackOrHome } from '@/utils/navigation'

const router = useRouter();
const authStore = useAuthStore();
const loggedIn = computed(() => authStore.isAuthenticated);
/*const theme = useTheme();*/

defineProps(['toggleStatus'])
/*
function toggleTheme() {
  theme.global.name.value = theme.global.current.value.dark ? 'light' : 'dark'
}*/

</script>

<style scoped>

header {
    grid-area: header;
    margin-top: 2px;
    background-color: bisque;
    /* making HEADER inside of the grid flexbox */
    display: flex;
    justify-content: center;
    align-items: center;
}

</style>
